<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}" class="status-button" @click="status = ACTIVE_STATUS">{{ $t('active') }}</button> <span  v-bind:class="{'font-weight-bold': status == ACTIVE_STATUS}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': status == DRAFT_STATUS}" class="status-button" @click="status = DRAFT_STATUS">{{ $t('draft') }}</button> <span  v-bind:class="{'font-weight-bold': status == DRAFT_STATUS}">({{draftCount}})</span> | <button v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}" class="status-button" @click="status = ARCHIVE_STATUS">{{ $t('archive') }}</button> <span  v-bind:class="{'font-weight-bold': status == ARCHIVE_STATUS}">({{archiveCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addStaticInfos">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('pages')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

const ACTIVE_STATUS = 'Active';
const DRAFT_STATUS = 'Draft';
const ARCHIVE_STATUS = 'Archive';

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      status: '',
      searchText: '',
      caption: i18n.t('staticInfos'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      // Provide access to consts on HTML
      ACTIVE_STATUS: ACTIVE_STATUS,
      DRAFT_STATUS: DRAFT_STATUS,
      ARCHIVE_STATUS: ARCHIVE_STATUS
    }
  },
  computed: {
    ...mapState('staticInfos', ['getStaticInfosOutput']),
    ...mapState('staticInfos', ['putStaticInfoStatusOutput']),
    staticInfosInfo: function() {
      return this.getStaticInfosOutput && this.getStaticInfosOutput.data ? this.getStaticInfosOutput.data : null;
    },
    items: function()
    {
      return this.staticInfosInfo && this.staticInfosInfo.staticInfos ? this.staticInfosInfo.staticInfos : [];
    },
    activeCount: function()
    {
      return this.staticInfosInfo ? this.staticInfosInfo.active : 0;
    },
    draftCount: function()
    {
      return this.staticInfosInfo ? this.staticInfosInfo.draft : 0;
    },
    archiveCount: function()
    {
      return this.staticInfosInfo ? this.staticInfosInfo.archive : 0
    },
    pages: function()
    {
      return this.listOutput ? this.listOutput.totalPages : 1;
    },
  },
  mounted: function()
  {
    this.status = ACTIVE_STATUS;
  },
  methods: {
    ...mapActions('staticInfos', ['getStaticInfos']),
    ...mapActions('staticInfos', ['putStaticInfoStatus']),
    rowClicked (item, index) {
      this.$router.push({name: "StaticInfosEdit", query: { id: item.id }, params: {title: item.title} });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "StaticInfosEdit", query: { id: item.id }, params: {title: item.title} });
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.title, { name: item.title }))){
            this.putStaticInfoStatus({ id: item.id, status: 3 });
          }
          break;
        }
        case 'enable':
        {
          if(confirm(this.$i18n.tc('confirmEnable', item.title, { name: item.title }))){
            this.putStaticInfoStatus({ id: item.id, status: 1});
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      
      // List specific parameters
      input.status = this.status;

      this.getStaticInfos(input); 
    },
    addStaticInfos () 
    {
      router.push({name: "StaticInfosAdd", params: { type: this.$route.params.type } });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    status: function (val) {
      // Update actions
      switch(val) {

        case ACTIVE_STATUS:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("archive") });
          
          break;
        }
        case DRAFT_STATUS:
        case ARCHIVE_STATUS:
        {
          this.actions = [];
        
          this.actions.push({ key: 'enable', label: this.$i18n.t("activate") });

          break;
        }
        default:
        {
          throw "The provided status is not supported!"; 
        }
      }

      // Update items
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    putStaticInfoStatusOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getStaticInfosOutput: function(val)
    {
      this.loading = false;
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 